import {
  PHYSICAL_INTENT_DURATION_MS,
  SEMANTIC_INTENT_DURATION_MS,
  FAST_INTENT_DURATION_MS,
} from "@/components/cursors/cursor-animation-types";
import type { AgentPresentationStep } from "./agent-presentation-types";

/** The pen rests this long on arrival before it starts drawing. */
export const PEN_TOUCH_DOWN_MS = 70;

/**
 * Operations show an overlay at the destination; only guides travel to it.
 *
 * A physical step in operate mode warns for the fast cue only: the user asked
 * Denker to do it, consent was given once for the request, and each pixel
 * step paid 300 ms on top of its capture. A guide keeps the longer warning.
 */
export function interactionCueDuration(
  step: AgentPresentationStep,
  mode?: "guide" | "operate",
): number | null {
  if (
    step.kind !== "click" &&
    step.kind !== "hover" &&
    step.kind !== "scroll" &&
    step.kind !== "paste"
  )
    return null;
  if (step.transition?.style === "instant") return 0;
  if (step.pace === "quick") return FAST_INTENT_DURATION_MS;
  const semantic = Boolean(step.semantic_target);
  const duration = step.transition?.duration_ms;
  if (duration !== undefined && duration <= 100) return Math.max(0, duration);
  if (mode === "operate" && !semantic) return FAST_INTENT_DURATION_MS;
  const minimum = semantic ? 150 : 250;
  const maximum = semantic ? 200 : 350;
  return Math.min(
    maximum,
    Math.max(
      minimum,
      duration ??
        (semantic ? SEMANTIC_INTENT_DURATION_MS : PHYSICAL_INTENT_DURATION_MS),
    ),
  );
}
